import "./ChannelManagerSetupDistributionStrategy.module.css";
import Header from "@/reusable_sections/Header";
import ChannelManagerHero from "./sections/ChannelManagerHero";
import Solutions from "./sections/Solutions";
import Implementation from "./sections/Implementation";
import Inventory from "./sections/Inventory";
import EfficiencyStats from "./sections/EfficiencyStats";
import Comparison from "./sections/Comparison";
import Faq from "./sections/Faq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function ChannelManagerSetupDistributionStrategyPage() {
  return <div>
      <Header />
      <ChannelManagerHero />
      <Solutions />
      <Implementation />
      <Inventory />
      <EfficiencyStats />
      <Comparison />
      <Faq />
      <Services />
      <Footer />
    </div>;
}